/* ÁUREA — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.au-reveal, .au-reveal-img, .au-steps__row');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('au-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('au-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('au-visible')) io.observe(el); });
  }

  function initHero(root) {
    (root || document).querySelectorAll('.au-hero').forEach(function (hero) {
      requestAnimationFrame(function () { hero.classList.add('au-ready'); });
      var img = hero.querySelector('[data-au-parallax]');
      if (!img || reduce) return;
      var k = parseFloat(img.getAttribute('data-au-parallax')) || 0;
      var ticking = false;
      function update() {
        var r = hero.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          img.style.transform = 'translate3d(0,' + (-r.top * k / 100) + 'px,0)';
        }
        ticking = false;
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  function initManifesto(root) {
    (root || document).querySelectorAll('.au-manifesto__text').forEach(function (box) {
      var parts = box.querySelectorAll('.au-manifesto__word, .au-manifesto__pill');
      if (reduce) { parts.forEach(function (p) { p.classList.add('is-on'); }); return; }
      var ticking = false;
      function update() {
        var r = box.getBoundingClientRect();
        var vh = window.innerHeight;
        var progress = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        progress = Math.max(0, Math.min(1, progress));
        var n = Math.round(progress * parts.length);
        parts.forEach(function (p, i) { p.classList.toggle('is-on', i < n); });
        ticking = false;
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  function initIngredients(root) {
    (root || document).querySelectorAll('.au-ingr').forEach(function (sec) {
      var items = sec.querySelectorAll('.au-ingr__item');
      var imgs = sec.querySelectorAll('.au-ingr__stage img');
      var bars = sec.querySelectorAll('.au-ingr__counter span');
      if (!items.length || !('IntersectionObserver' in window)) return;
      function activate(i) {
        items.forEach(function (el, j) { el.classList.toggle('is-active', i === j); });
        imgs.forEach(function (el, j) { el.classList.toggle('is-active', i === j); });
        bars.forEach(function (el, j) { el.classList.toggle('is-active', i === j); });
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(items, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (el) { io.observe(el); });
      activate(0);
    });
  }

  function initBeforeAfter(root) {
    (root || document).querySelectorAll('.au-ba__frame').forEach(function (frame) {
      var range = frame.querySelector('.au-ba__range');
      if (!range) return;
      function set(v) { frame.style.setProperty('--au-pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('[data-au-faq-single]').forEach(function (list) {
      var items = list.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('.au-pdp').forEach(function (pdp) {
      var main = pdp.querySelector('.au-pdp__main img');
      var thumbs = pdp.querySelectorAll('.au-pdp__thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.srcset = '';
            main.alt = t.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
          thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
        });
      });

      // Cantidad
      var qty = pdp.querySelector('.au-pdp__qty input');
      pdp.querySelectorAll('[data-au-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-au-qty'), 10));
        });
      });

      // Variantes
      var json = pdp.querySelector('[data-au-variants]');
      var selects = pdp.querySelectorAll('.au-pdp__option select');
      if (json && selects.length) {
        var variants = JSON.parse(json.textContent);
        var idInput = pdp.querySelector('input[name="id"]');
        var priceEl = pdp.querySelector('[data-au-price]');
        var compareEl = pdp.querySelector('[data-au-compare]');
        var btns = pdp.querySelectorAll('[data-au-add]');
        var fmt = json.getAttribute('data-money') || '{{amount}}';
        function money(cents) {
          var v = (cents / 100).toFixed(2);
          return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*[a-z_]+\s*\}\}/, v.replace('.', ','));
        }
        function onChange() {
          var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
          btns.forEach(function (b) {
            b.disabled = !v || !v.available;
            var label = b.querySelector('[data-au-label]');
            if (label) label.textContent = !v ? b.getAttribute('data-unavailable') : (v.available ? b.getAttribute('data-add') : b.getAttribute('data-soldout'));
          });
          if (!v) return;
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
        }
        selects.forEach(function (s) { s.addEventListener('change', onChange); });
      }

      // Barra de compra fija en móvil/scroll
      var sticky = pdp.querySelector('.au-pdp__sticky');
      var form = pdp.querySelector('.au-pdp__qtyrow');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(form);
        var stickyBtn = sticky.querySelector('button');
        if (stickyBtn) stickyBtn.addEventListener('click', function () {
          var mainBtn = pdp.querySelector('.au-pdp__qtyrow [data-au-add]');
          if (mainBtn) mainBtn.click();
        });
      }
    });
  }

  function initAll(root) {
    initReveals(root); initHero(root); initManifesto(root); initIngredients(root);
    initBeforeAfter(root); initFaq(root); initGallery(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Editor de Shopify: re-inicializar al recargar una sección
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
